import { graphql } from 'react-relay'

export const settingsQuery = graphql`
  query ConfigurationServiceGlobalSettingsQuery {
    globalSettings {
      betLimits {
        currency
        limits
      }
      betLimitsMp {
        currency
        limits
      }
      disabled
      rainLimits
      tipLimits {
        tipMax
        tipMin
      }
    }
  }
`

export const globalSettingsUpdatedSubscription = graphql`
  subscription ConfigurationServiceGlobalSettingsUpdatedSubscription {
    globalSettingsUpdated {
      betLimits {
        currency
        limits
      }
      betLimitsMp {
        currency
        limits
      }
      disabled
      rainLimits
      tipLimits {
        tipMax
        tipMin
      }
    }
  }
`
